import { render } from "./BaseCheckboxToggle.vue?vue&type=template&id=3851d2f4&scoped=true"
import script from "./BaseCheckboxToggle.vue?vue&type=script&lang=js"
export * from "./BaseCheckboxToggle.vue?vue&type=script&lang=js"

import "./BaseCheckboxToggle.vue?vue&type=style&index=0&id=3851d2f4&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3851d2f4"]])

export default __exports__